<script>
import BAteTreeForm from '@/components/forms/BAteTree/BAteTreeForm.vue'
import { AteMunicipalitiesApi, AteRegionsApi, AteSchoolsApi } from '@/api/resources'

const getData = (response) => response?.data || response || []

export default {
  name: 'BAteTreeFormFormdataStarted',
  extends: BAteTreeForm,
  data: () => ({
    get regionsApi() {
      return {
        getAll: ({ search, pageSize }, config) => new AteRegionsApi()
          .getAllLK(
            { search, pageSize },
            config,
          ).then(getData),
      }
    },
    get municipalitiesApi() {
      return {
        getAll: ({ region_id, search }, config) => new AteMunicipalitiesApi()
          .getAllLK(
            { region_id, search },
            config,
          ).then(getData),
      }
    },
    get schoolsApi() {
      return {
        getAll: ({ municipality_id, search }, config) => new AteSchoolsApi()
          .getAllLK(
            { municipality_id, search },
            config,
          ).then(getData),
      }
    },
  }),
}
</script>
